import type { ComponentMultiStyleConfig } from "@chakra-ui/react"

// BARNES Design System accordion (dist/css/accordion.css), compact + flush, for the advanced
// filters drawer (ADR 0003, D3). Only the "filters" variant is styled: other accordions (admin
// menu) keep their current look.
export const Accordion: ComponentMultiStyleConfig = {
  parts: ["root", "container", "button", "panel", "icon"],
  variants: {
    filters: {
      root: {
        borderTop: "1px solid",
        borderTopColor: "line",
      },
      container: {
        borderTop: "none",
        borderBottom: "1px solid",
        borderBottomColor: "line",
        _last: {
          borderBottomWidth: "1px",
        },
      },
      button: {
        gap: 4,
        px: 0,
        py: 4,
        fontSize: "md",
        fontWeight: "normal",
        color: "text",
        bg: "transparent",
        transitionProperty: "color",
        transitionDuration: "240ms",
        _hover: {
          color: "accent",
          bg: "transparent",
        },
        _expanded: {
          fontWeight: "semibold",
          _hover: {
            color: "text",
          },
        },
      },
      panel: {
        px: 0,
        pt: 3,
        pb: 5,
      },
      icon: {
        color: "textMuted",
      },
    },
  },
}
